<template>
    <modal
        class="is-narrow"
        v-bind:title="__('Edit video')"
        v-bind:is-open="isOpen"
        v-on:close-modal="closeModal"
        v-bind:slot-props="errors"
    >
        <template v-slot:body>
            <div class="has-margin-b30">
                <control
                    name="titleEditControl"
                    type="text"
                    v-bind:label="__('Title')"
                    v-model="editedVideo.title"
                />
                <div
                    class="has-text-danger has-margin-b10"
                    v-if="errors.title != null"
                >
                    {{ errors.title[0] }}
                </div>
            </div>
            <div class="has-margin-b30">
                <control
                    name="orientationEditControl"
                    type="select"
                    v-bind:label="__('Orientation')"
                    v-model="editedVideo.orientation"
                    v-bind:options="orientations"
                />
                <div
                    class="has-text-danger has-margin-b10"
                    v-if="errors.orientation != null"
                >
                    {{ errors.orientation[0] }}
                </div>
            </div>
            <div class="has-margin-b30">
                <control
                    name="fileEditControl"
                    type="file"
                    ref="editFileControl"
                    v-bind:filename="editedVideo.video"
                    v-bind:label="__('File')"
                    v-model="editedVideo.file"
                />
                <div
                    class="has-text-danger has-margin-b10"
                    v-if="errors.file != null"
                >
                    {{ errors.file[0] }}
                </div>
            </div>
        </template>
        <template v-slot:footer>
            <btn
                class="is-block is-success"
                type="default"
                v-html="__('Save')"
                v-on:click="updateVideo"
            ></btn>
        </template>
    </modal>
</template>

<script>
import { Btn, Control, Modal } from '@teamfurther/cinderblock';
import videoConfig from '../../../config/videoConfig';
import StringService from '../../../services/StringService';

export default {
    components: {
        Btn,
        Control,
        Modal
    },
    computed: {
        orientations: function() {
            return videoConfig.orientations.map(item => {
                return {
                    label: StringService.capitalize(item),
                    value: item
                };
            });
        }
    },
    data: function() {
        return {
            editedVideo: {
                id: null,
                file: null,
                title: '',
                video: '',
                name: '',
                orientation: 'horizontal'
            }
        };
    },
    methods: {
        closeModal: function() {
            this.$emit('close');
        },
        updateVideo: function() {
            this.editedVideo.name = this.$refs.editFileControl.selectedFilename;

            this.$emit('update', this.editedVideo);
        }
    },
    props: {
        errors: {
            required: true
        },
        isOpen: {
            required: true
        },
        video: {
            required: true
        }
    },
    watch: {
        video: function() {
            this.editedVideo = this.video;
        }
    }
};
</script>
